import { ethers } from 'ethers'

const getDataString = (providerId: string, timestamp: number): string => {

    const data = {
        "providerId": providerId,
        "timestamp": timestamp,
    };

    return JSON.stringify(data);
}

export const generateSignature = async (applicationSecret: string, providerId: string, timestamp: number): Promise<string | undefined> => {
  try {
    const wallet = new ethers.Wallet(applicationSecret);
    const signature = (await wallet.signMessage(
      ethers.getBytes(
        ethers.keccak256(new TextEncoder().encode(getDataString(providerId, timestamp)))
      )
    ));

    return signature;
  } catch (err) {
    console.error("Error generating signature:", err);
  }

  return undefined;
};
